import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { GoldButton } from './Shared';
export const Hero = () => {
  const quickBadges = [{
    icon: '📚',
    label: '6 Módulos Profesionales'
  }, {
    icon: '🎁',
    label: '4 Bonos Exclusivos'
  }, {
    icon: '📜',
    label: 'Certificado Digital'
  }, {
    icon: '⚡',
    label: 'Acceso Inmediato'
  }, {
    icon: '💻',
    label: '100% Digital'
  }];
  const features = [{
    icon: '🏆',
    label: 'Formación clara y organizada paso a paso'
  }, {
    icon: '🔮',
    label: 'Interpretación astrológica desde cero'
  }, {
    icon: '📥',
    label: 'Descarga inmediata'
  }];
  return <section className="relative flex items-center pt-6 pb-8 sm:pt-24 sm:pb-16 overflow-hidden z-10" data-id="element-83">
      {/* Subtle background glow behind hero */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[460px] h-[460px] sm:w-[800px] sm:h-[800px] bg-gold/10 rounded-full blur-[80px] sm:blur-[120px] pointer-events-none" data-id="element-84"></div>

      <div className="container mx-auto px-6 relative" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-86">
          <div className="inline-block px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-gold/30 bg-celestial-800/50 backdrop-blur-sm mb-2 sm:mb-6" data-id="element-87">
            <span className="text-gold-light text-xs sm:text-sm font-medium tracking-wider uppercase" data-id="element-88">
              Formación Integral Profesional
            </span>
          </div>

          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-serif text-gold-light leading-tight mb-2 sm:mb-4" data-id="element-89">
            Aprendé a Leer e Interpretar los Registros Akáshicos
          </h1>

          <p className="text-sm sm:text-lg text-indigo-100/90 mb-3 sm:mb-6 font-light leading-relaxed max-w-2xl" data-id="element-90">
            Formación profesional diseñada para ayudarte a conectar con los
            Registros Akáshicos, interpretar mensajes con claridad y desarrollar
            una práctica consciente.
          </p>

          {/* Mockup directly below the subtitle */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.92
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative w-full max-w-[180px] sm:max-w-2xl mb-3 sm:mb-6" data-id="element-91">
            {/* Soft radial glow behind the bundle */}
            <div className="absolute inset-0 bg-gold/15 blur-[50px] sm:blur-[80px] rounded-full pointer-events-none scale-90" data-id="element-92"></div>

            <motion.img src="https://cdn.magicpatterns.com/uploads/gYTJfFH97jkoL6tHp2wMpx/ChatGPT_Image_22_jun_2026,_16_39_29.png" alt="Formación completa de Registros Akáshicos: 6 módulos y 4 bonos premium de Academia Holística Argentina" className="relative z-10 w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.6)]" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-93" />
          </motion.div>

          {/* Rating */}
          <div className="flex flex-col items-center gap-1 mb-2 sm:mb-5" data-id="element-94">
            <div className="flex items-center gap-1" data-id="element-95">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-gold fill-gold" data-id="element-96" />)}
            </div>
            <p className="text-xs sm:text-sm text-indigo-100/80" data-id="element-97">
              <span className="text-gold-light font-semibold" data-id="element-98">4.9/5</span> ·
              +800 alumnos de Argentina
            </p>
          </div>

          {/* CTA */}
          <GoldButton href="#caja-oferta" className="w-full sm:w-auto" data-id="element-99">
            👉 QUIERO ACCEDER A LA FORMACIÓN
          </GoldButton>
          <p className="text-xs sm:text-sm text-indigo-100/60 mt-2 mb-4 sm:mt-3 sm:mb-6" data-id="element-100">
            Acceso inmediato luego de completar tu compra.
          </p>

          {/* Quick badges */}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 sm:gap-x-5 sm:gap-y-2 mb-4 sm:mb-5 max-w-2xl" data-id="element-101">
            {quickBadges.map((badge, idx) => <span key={idx} className="flex items-center gap-1.5 text-sm text-indigo-100/85" data-id="element-102">
                <span aria-hidden="true" data-id="element-103">{badge.icon}</span>
                {badge.label}
              </span>)}
          </div>

          {/* Feature highlights */}
          <div className="flex flex-col items-center gap-2" data-id="element-104">
            {features.map((feature, idx) => <span key={idx} className="flex items-center gap-2 text-sm md:text-base text-indigo-100/90" data-id="element-105">
                <span aria-hidden="true" data-id="element-106">{feature.icon}</span>
                {feature.label}
              </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
};